var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M264.255 111.742C263.59 172.197 214.41 221 153.842 221 92.86 221 43.423 171.527 43.423 110.5c0-5.053.34-10.026.995-14.899H9.933C4.447 95.601 0 91.154 0 85.67c0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H42.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H71.17C91.401 14.401 120.941 0 153.842 0 201.3 0 241.763 29.96 257.38 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M87.063 109.376v67.322l75.555 12.283V105.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M134.736 80.537L152.444 67l77.015 12.662-18.017 13.203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M162.288 106.087v82.14l49.513-12.636v-65.054"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M86.346 92.605L66 105.637l79.123 15.596 16.51-15.596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    d: "M162.352 106.325l17.99 14.732 46.909-15.877-15.917-12.478M85.643 92.963l-16.634-11.29 49.4-11.66 16.17 10.345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M87.063 93.122l76.068 12.966 46.633-13.265-75.085-12.267z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1.5,
    d: "M199.9 168.634h4.741v-8.251"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EB8181",
    transform: "matrix(1 0 0 -1 182 190)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    d: "M202 177.778v-15.802"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M194.222 168.889l7.727-6.81 7.343 6.81"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M97.5 136.604v19.982l20 3.81v-19.982l-20-3.81z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M97.5 160.5l20 4.004M97.5 164.5l20 4.004M97.5 168.5l13.139 2.691"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProducts);
export default __webpack_public_path__ + "static/media/upload-products.e466964bd11f98c28b5743df70be2af2.svg";
export { ForwardRef as ReactComponent };